import { render, staticRenderFns } from "./WikidataLocations.vue?vue&type=template&id=e2ec9d58&"
import script from "./WikidataLocations.vue?vue&type=script&lang=js&"
export * from "./WikidataLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports